import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tinycolor from "tinycolor2";
import Err from "../../../../../../routes/error";
import { mapActions, mapMutations } from "vuex";
import { UPDATE_APPLICATION_FLOW, LOAD_CALCULATIONS_DATA } from "../../store/application-actions";
import { isEmpty, keyBy, mapValues, trim } from "lodash";
import { defineComponent } from "@vue/composition-api";
import ApplicationFlowModal from "./application-flow-modal";
import { DELETE_ALL_PROPERTY_EXISTING_MORTGAGES } from "../../store/application-mutations";
export default defineComponent({
  name: "ApplicationFlowDropdown",
  components: {
    ApplicationFlowModal
  },
  props: {
    flows: {
      type: Array,
      required: true
    },
    currentFlow: {
      type: String,
      required: true
    },
    clientUsername: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    applicationId: {
      required: true,
      validator: prop => typeof prop === "number" || prop === null
    },
    badge: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      deleteExisting: false
    };
  },
  computed: {
    remainingFlows() {
      var _context;
      return _filterInstanceProperty(_context = this.flows).call(_context, ({
        key
      }) => key !== this.currentFlow);
    },
    normalizedFlows() {
      return mapValues(keyBy(this.flows, "key"), "title");
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("ApplicationStore", [UPDATE_APPLICATION_FLOW, LOAD_CALCULATIONS_DATA])), mapMutations("ApplicationStore", [DELETE_ALL_PROPERTY_EXISTING_MORTGAGES])), {}, {
    showModal(flow) {
      const {
        clientUsername,
        applicationId
      } = this;
      // If applicationId is falsy, the action was called
      // from the Application Form Customization page
      if (!applicationId || isEmpty(clientUsername)) {
        // just update, nothing else (note function UPDATE_APPLICATION_FLOW does similar check too)
        try {
          this.UPDATE_APPLICATION_FLOW({
            clientUsername,
            applicationId,
            flow
          });
        } catch (e) {
          Err.handle(e);
        }
        return;
      }

      // Switching from Refinance or Switch/Transfer to Purchase or Pre-Approval
      this.deleteExisting = (this.currentFlow === "refinance-approval" || this.currentFlow === "switch-transfer") && (flow === "purchase-approval" || flow === "purchase-preapproval");
      if (this.deleteExisting) this.$nextTick(() => this.$refs.modal.$show(flow));else this.handleChangeFlow(flow);
    },
    async handleChangeFlow(flow) {
      if (this.deleteExisting) this.DELETE_ALL_PROPERTY_EXISTING_MORTGAGES();
      try {
        const {
          clientUsername,
          applicationId
        } = this;
        await this.UPDATE_APPLICATION_FLOW({
          clientUsername,
          applicationId,
          flow
        });
        await this.LOAD_CALCULATIONS_DATA({
          clientUsername,
          applicationId
        });
      } catch (e) {
        Err.handle(e);
      }
    },
    getCurrentColours() {
      const bodyStyles = window.getComputedStyle(document.body);
      const primary = trim(bodyStyles.getPropertyValue("--primary"));
      const secondary = trim(bodyStyles.getPropertyValue("--secondary"));
      const primaryAlt = trim(bodyStyles.getPropertyValue("--primary-alt"));
      const primaryRGB = trim(bodyStyles.getPropertyValue("--primary-rgb"));
      const primaryClear = trim(bodyStyles.getPropertyValue("--primary-clear"));
      return {
        primary,
        secondary,
        primaryAlt,
        primaryRGB,
        primaryClear
      };
    },
    getSecondaryComplement() {
      if (!this.badge) return "#fff";
      const {
        secondary
      } = this.getCurrentColours();
      return tinycolor(secondary).complement().toHexString();
    },
    getFlowTitle(flow) {
      return this.normalizedFlows[flow];
    }
  })
});